import { render, staticRenderFns } from "./ReviewLandingPagePreview.vue?vue&type=template&id=6b888ac8&scoped=true"
import script from "./ReviewLandingPagePreview.vue?vue&type=script&lang=js"
export * from "./ReviewLandingPagePreview.vue?vue&type=script&lang=js"
import style0 from "./ReviewLandingPagePreview.vue?vue&type=style&index=0&id=6b888ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b888ac8",
  null
  
)

export default component.exports